import { render, staticRenderFns } from "./AppSidebarNavLabel.vue?vue&type=template&id=08862a89&"
import script from "./AppSidebarNavLabel.vue?vue&type=script&lang=js&"
export * from "./AppSidebarNavLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports